import { render, staticRenderFns } from "./XhBusinessStatus.vue?vue&type=template&id=05cd65c8&scoped=true"
import script from "./XhBusinessStatus.vue?vue&type=script&lang=js"
export * from "./XhBusinessStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cd65c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05cd65c8')) {
      api.createRecord('05cd65c8', component.options)
    } else {
      api.reload('05cd65c8', component.options)
    }
    module.hot.accept("./XhBusinessStatus.vue?vue&type=template&id=05cd65c8&scoped=true", function () {
      api.rerender('05cd65c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhBusinessStatus.vue"
export default component.exports